import { Pipe, PipeTransform } from '@angular/core';
import { Hours, Milliseconds, Minutes, Seconds } from '../../types';

const millisecondsInSecond = 1000;
const millisecondsInMinute = 60 * millisecondsInSecond;
const millisecondsInHour = 60 * millisecondsInMinute;

@Pipe({
  name: 'seconds'
})
export class SecondsPipe implements PipeTransform {
  transform(milliseconds: Milliseconds, isSeconds = false): string {
    if (isSeconds) {
      milliseconds *= 1000;
    }

    const hours = getHours(milliseconds);

    milliseconds -= hours * millisecondsInHour;

    const minutes = getMinutes(milliseconds);

    milliseconds -= minutes * millisecondsInMinute;

    const seconds = getSeconds(milliseconds);

    const result = padNumber(minutes, 2) + ':' + padNumber(seconds, 2);

    return hours ? padNumber(hours, 2) + ':' + result : result;
  }
}

function padNumber(number: number, length: number): string {
  let string: string = number.toString();

  while (string.length < length) {
    string = '0' + string;
  }

  return string;
}

function getHours(milliseconds: Milliseconds): Hours {
  return Math.floor(milliseconds / millisecondsInHour);
}

function getMinutes(milliseconds: Milliseconds): Minutes {
  return Math.floor(milliseconds / millisecondsInMinute);
}

function getSeconds(milliseconds: Milliseconds): Seconds {
  return Math.floor(milliseconds / millisecondsInSecond);
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/seconds.pipe.ts